export default __webpack_public_path__ + "static/media/icon-logo.33daa179.png";